import React from "react";
import { ToastContainer } from "react-toastify";
import AgentRoster from "../components/AgentRoster";

const AgentRosterApp = (props) => (
  <React.Fragment>
    <ToastContainer icon={false} />
    <AgentRoster {...props} />
  </React.Fragment>
);

export default AgentRosterApp;
